import { useLocation } from '@reach/router';
import { PageContext } from '@contexts/page-context';
import React from 'react';

const useLocationPathName = () => {
  const location = useLocation();
  const { pageProps } = React.useContext(PageContext);
  // console.log('TODO IB location', location);
  // console.log('TODO IB pageProps', pageProps);
  if (pageProps?.pageContext?.additionalLanguage) {
    const additionalLanguage = pageProps?.pageContext?.additionalLanguage;
    return location.pathname
      .replace(new RegExp('^/' + additionalLanguage + '/'), '')
      .replace(new RegExp('^/' + additionalLanguage + '$'), '');
  } else {
    return location.pathname.replace(/^(\/)/, '');
  }
};

export default useLocationPathName;
